import LocationModal from '../LocationModal'
import LocationImport from '../LocationImport'
import locationService from '../../../../services/notisphere/location'
import { Notisphere_Location_AgGrid, AG_GridCustomizedTableHeaders_Key } from '../../../../misc/tableHeaders'
import _ from 'lodash'

export default {
    props: {
        supplierOrgId: { type: Number, default: null }
    },
    components: {
        LocationModal,
        LocationImport
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            total: 0,
            items: [],
            gridApi: null,
            columnApi: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            search: {
                idn: null,
                state: null,
                city: null,
                verified: null
            },
            locationModalKey: 0,
            locationImportKey: 0,

            listIDN: [],
            listCity: [],
            listState: [],
            listStatus: [{ text: 'Covered', value: 'Covered' },{ text: 'Invalid', value: 'Invalid' },
                { text: 'Not Covered', value: 'NotCovered' },{ text: 'Not Mapped', value: 'Not Mapped' }, { text: 'Pending', value: 'Pending' }],
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_Location_AgGrid
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    mounted() {
        this.getSearchMeta()
    },
    methods: {
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        addMoreClick() {
            this.locationModalKey += 1
            this.$nextTick(() => {
                this.$refs.locationModal.forceRerenderInsert()
            })
        },
        updateLocation(payload) {
            this.locationModalKey += 1
            this.$nextTick(() => {
                this.$refs.locationModal.forceRerenderUpdate(payload.location_id)
            })
        },
        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.filterModel = that.gridApi.getFilterModel()
                    const filterModel = that.gridApi.getFilterModel()
                    locationService.sup_findLocation({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        search: that.searchQuery.globalSearch,
                        ...that.search,
                    }, that.supplierOrgId).then(resp => {
                        if (!resp.error) {
                            that.total = resp.data.d.t
                            if (that.total == 0) {
                                that.gridApi.showNoRowsOverlay()
                            } else {
                                that.gridApi.hideOverlay()
                            }
                            return resp.data.d.c
                        }
                    }).then(response => {
                        params.successCallback(response)
                    }).catch(error => {
                        console.error(error)
                        params.failCallback()
                    })
                }
            }
            // register datasource with the grid
            params.api.setServerSideDatasource(datasource)
        },
        deleteLocation(item, e) {
            this._showConfirm('You are about to delete this location, this cannot be undone.').then(confirm => {
                if (confirm) {
                    locationService.sup_deleteLocation(item.location_id, this.supplierOrgId).then(resp => {
                        if (!resp.error) {
                            this.onCompleted('UPDATE')
                        }
                    })
                }
            })
            if (e) {
                e.stopPropagation()
            }
        },
        importFile() {
            this.locationImportKey += 1
            this.$nextTick(() => {
                this.$refs.locationImport.forceRerenderInsert()
            })
        },
        getSearchMeta() {
            locationService.sup_getSearchMeta(this.supplierOrgId).then(resp => {
                if (!resp.error) {
                    var data = resp.data.d
                    this.listIDN = [
                        ...data.idn.map(x => { return { text: x, value: x } })
                    ]
                    this.listCity = [
                        ...data.city.map(x => { return { text: x, value: x } })
                    ]
                    this.listState = [
                        ...data.state.map(x => { return { text: x, value: x } })
                    ]
                }
            })
        },
        applyFilters() {
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        // AG Grid specific methods
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.filterModel = that.gridApi.getFilterModel()
            const filterModel = that.gridApi.getFilterModel()
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...searchquery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        search: that.searchQuery.globalSearch,
                        ...that.search,
                        email: email,
                    }
                    const resp = await locationService.downloadAgGridNotisphereLocationXLSX(query_param, that.supplierOrgId)
                    console.log(resp)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Location_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Location_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Notisphere_Login.Location_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.Location_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onCellClicked(params) {
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'delete') {
                    this.deleteLocation(params.data)
                }
                return
            }
            // Handle row click to edit location (similar to original behavior)
            this.updateLocation(params.data)
        },
        onGlobalSearchChange(searchValue) {
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }
    }
}